import { render, staticRenderFns } from "./CardStatsV5.vue?vue&type=template&id=1f8d59d0&scoped=true&"
import script from "./CardStatsV5.vue?vue&type=script&lang=js&"
export * from "./CardStatsV5.vue?vue&type=script&lang=js&"
import style0 from "./CardStatsV5.vue?vue&type=style&index=0&id=1f8d59d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d59d0",
  null
  
)

export default component.exports